<template>
  <c-box class="solutions_breadcrumb" font-size="sm">
    <ol v-chakra margin="0" list-style="none" py="md">
      <li
        v-for="(item, index) in path"
        :key="index"
        v-chakra
        d="inline"
        font-size="sm"
        font-weight="normal"
        pr="xs"
      >
        <c-icon v-if="index > 0" name="chevron_right" size="0.75rem" mr="xs" />
        <router-link
          v-if="!isConcealed(item)"
          :to="item.href"
          v-chakra
          :_hover="{
            color: 'black',
            textDecoration: 'underline',
          }"
          >{{ (item.name || "").trim() }}</router-link
        >
        <c-text v-else as="span" color="gray.500">{{ (item.name || "").trim() }}</c-text>
      </li>
    </ol>
  </c-box>
</template>

<script lang="ts">
import { isConcealedCategory } from "@/util/SolutionUtil";
import { CBox, CIcon, CText } from "@chakra-ui/vue";
import { defineComponent, PropType } from "vue";
import { BreadcrumbItem } from "./breadcrumb-item";

export default defineComponent({
  name: "Breadcrumb",
  components: {
    CBox,
    CText,
    CIcon,
  },
  props: {
    path: {
      type: Array as PropType<BreadcrumbItem[]>,
      required: true,
    },
  },
  methods: {
    isConcealed(item: BreadcrumbItem): boolean {
      const match = item.href.match(/\/categories\/(\d+)\/?/);
      return !!match && isConcealedCategory(parseInt(match[1]));
    },
  },
});
</script>
